import React, { useState } from 'react'
import { Link, useLocation } from "react-router-dom";


import { ProfileStatus } from '../AddDoctor/ProfileStatus'
import { QCStatus } from '../AddDoctor/QCStatus'
import { SwitchTabWarningDialog } from '../SwitchTabDialog';
import { routerLink } from "../constant"


export const DoctorProfileHeader = ({ doctorProfileDetails }) => {
    const doctorDetails = (doctorProfileDetails?.doctors[0])
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const doctorId = queryParams.get('drId') || doctorDetails?.doctorId || '';
    const isHolidayTabActive = queryParams.get('drId') ? true : false;
    const [showDialog, setShowDiaglog] = useState(false);
    const [nextPage, setNextPage] = useState();



    const redirect = (path) => {
        setShowDiaglog(true);
        setNextPage(path);
    }

    return (
        <div className="flex items-center justify-between gap-4 py-4">
            {doctorId ? <ProfileStatus
                statusValue={doctorDetails?.profilePercentComplete}
                statusImage={doctorDetails?.doctorImageUrl ? doctorDetails.doctorImageUrl : "/assets/DoctorPlaceholder.svg"}
                isProgressBarRequired={doctorId ? true : false}
            />
                : <img
                    style={{ width: 64, marginTop: -5, height: 64 }}
                    src={doctorDetails?.doctorImageUrl ? doctorDetails.doctorImageUrl : "/assets/doctorProfileImage.svg"}
                    alt="DoctorImage"
                />
            }

            <div className="flex flex-col flex-1">
                <div className="flex flex-row gap-2">
                    <p className=' text-2xl font-semibold justify-center py-1 '>
                        {doctorDetails?.doctorFirstName ? ` ${doctorDetails?.doctorFirstName} ${doctorDetails?.doctorLastName || ''}` : 'New Doctor'}
                    </p>
                    <div className="flex py-2 justify-center">
                        <QCStatus
                            qcStatus={doctorDetails?.doctorQCStatus || 'Draft'}
                            qcRemarks={doctorDetails?.doctorQCRemarks} />
                    </div>
                </div>
                <p className="text-s text-gray-500 ">

                    {
                        doctorDetails?.doctorId ?
                            <> ID : {doctorDetails.doctorId} </>
                            : "Doctor ID generated post QC will show here"
                    }
                </p>
            </div>

            <div className="flex border rounded-xl bg-[#F5F7F8] gap-4 ">
                <div
                    className={`flex  ${routerLink.profilePage == location.pathname ? 'bg-white text-[#0066DC]' : 'text-[#70829B]'} items-center justify-center rounded-xl p-2  m-1 `}
                    onClick={() => { isHolidayTabActive ? redirect(`${routerLink.profilePage}?drId=${doctorId}`) : redirect(`${routerLink.profilePage}`) }}
                >
                    Doctor Profile
                </div>
                <div className={`flex  ${routerLink.schedule == location.pathname ? 'bg-white text-[#0066DC]' : 'text-[#70829B]'} items-center justify-center rounded-xl p-2 m-1`}
                    onClick={() => { isHolidayTabActive ? redirect(`${routerLink.schedule}?drId=${doctorId}`) : redirect(`${routerLink.schedule}`) }}
                >
                    Schedule
                </div>
                {isHolidayTabActive && <div className={`flex  ${routerLink.holidays == location.pathname ? 'bg-white text-[#0066DC]' : 'text-[#70829B]'} items-center justify-center rounded-xl p-2 m-1`}
                    onClick={() => redirect(`${routerLink.holidays}?drId=${doctorId}`)}>
                    Holidays
                </div>
                }
            </div>
            {showDialog && <SwitchTabWarningDialog showDialog={showDialog} setShowDialog={setShowDiaglog} pageToRedirectTo={nextPage}></SwitchTabWarningDialog>}
        </div>
    )
}